import './Notfound.css';

function Notfound(){

    return(
        <div className="notfound">
            <h1>Page Not Found!</h1>
            <img src="https://valenmine.netlify.app/images/Love%20is%20in%20the%20air-pana.png" alt="" />
        </div>
    )
}

export default Notfound;